// @flow

import styled, { type ReactComponentStyled } from 'styled-components';

import type { ColorHex, Theme } from '../typings';

type Props = {
  theme: Theme,
  themeColor: string,
  separatorColor: ColorHex
};

const HorizontalSeparator: ReactComponentStyled<Props> = styled.div`
  width: 100%;
  border-top: 1px solid ${props => props.theme[props.themeColor] || props.theme.separatorColor};
`;

export default HorizontalSeparator;
